<nav class="navbar navbar-expand-lg navbar-dark bg-dark py-0 small footerNav">
  <ul class="navbar-nav">
    <li class="nav-item first">
      <a class="nav-link" routerLink="/imprint" angulartics2On="click" angularticsAction="imprint" angularticsCategory="navigation" >
        <span i18n="Link to Imprint section@@footer.link.Imprint">Imprint</span>
      </a>
    </li>
    <li class="nav-item">
      <a class="nav-link" href="https://agb.traviangames.com/privacy-en-Arkheim.pdf" target="_blank" angulartics2On="click" angularticsAction="privacyPolicy" angularticsCategory="navigation" >
        <span i18n="Link to Privacy Policy@@header.link.Privacy">Privacy Policy</span>
      </a>
    </li>
    <li class="nav-item">
      <a class="nav-link" href="https://static.arkheim.com/arkheim_game_rules.pdf" target="_blank" angulartics2On="click" angularticsAction="gameRules" angularticsCategory="navigation" >
        <span i18n="Link to Game-Rules@@header.link.GameRules">Game Rules</span>
      </a>
    </li>
  </ul>
  <ul class="navbar-nav ml-auto">
    <li class="nav-item">
      <a class="nav-link" href="http://www.traviangames.com/" target="_blank" angulartics2On="click" angularticsAction="travianGamesCopyRight" angularticsCategory="navigation" >
        <span i18n="Copy right@@footer.link.copyright">&copy; 2021 Travian Games GmbH</span>
      </a>
    </li>
  </ul>
</nav>
